export const FORGOTPASSWORD_ROUTE_INDICATOR="FORGOTPASSWORD_ROUTE_INDICATOR";

export const VERIFY_EMAIL_OTP_DONE="VERIFY_EMAIL_OTP_DONE"
export const SET_TOKEN_DONE="SET_TOKEN_DONE"
export const AUTH_401_REDIRECT="AUTH_401_REDIRECT"